import type { ManualStatus } from "@/api/db/connection";
import { ManualLabels } from "@/lib/labels/manuals";
import { cn } from "@/lib/utils";

const TONE: Record<ManualStatus, string> = {
	draft: "border-border bg-border/40 text-muted-foreground",
	delivered: "border-info/40 bg-info/10 text-info",
	revoked: "border-destructive/40 bg-destructive/10 text-destructive",
};

export function DocumentStatus({ status }: { status: ManualStatus }) {
	return (
		<span
			className={cn(
				"inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
				TONE[status],
			)}
		>
			{ManualLabels.status[status]}
		</span>
	);
}
